<template>
    <div class="root">
        <div class="images">
            <img class="selection-image-previous" :src="`images/genres/${previousPreset?.selection?.toLowerCase() ?? ''}.png`" />
            <img class="selection-image" :src="`images/genres/${selectedPreset?.selection?.toLowerCase() ?? ''}.png`" />
            <img class="selection-image-next" :src="`images/genres/${nextPreset?.selection?.toLowerCase() ?? ''}.png`" />
        </div>
    </div>
</template>

<style lang="scss" scoped>

.root {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.images {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 20px;
    gap: 1rem;
    overflow: hidden;

    img {
        align-self: center;
    }

    .selection-image {
        width: 300px;
        max-width: 100%;
    }

    .selection-image-previous, .selection-image-next {
        width: 250px;
        opacity: 0.5;

        @media (max-width: 600px) {
            display: none;
        }
    }
}

</style>

<script>

export default {
    name: 'PresetSelector',
    props: {
        selectedPreset: {
            type: Object,
            required: false
        },
        previousPreset: {
            type: Object,
            required: false
        },
        nextPreset: {
            type: Object,
            required: false
        },
        msg: {
            type: String,
            required: false
        }
    },
    emits: ['presetClick', 'presetHover', 'presetHoverOut'],
};
</script>